import { Component } from '@angular/core';
import { BaseAdvancedPropertyViewComponent } from '../base-advanced-property-view.component';
import { StairsComponent } from 'src/app/models/components/objectComponents/StairsComponent';
import { getComponentFromSource } from 'src/app/generics-helper/getComponentFromSource.generic';
import { ComponentNames } from 'src/app/helper/componentNames';
import { PersonsPerSquareMeterComponent } from 'src/app/models/components/commonComponents/PersonsPerSquareMeterComponent';
import { AuthService } from 'src/app/services/auth.service';
import { userHasFeature } from 'src/app/helper/userHasFeature';
import { FeatureEnum } from 'src/app/models/enums/FeatureEnum';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-stair',
  templateUrl: './stair.component.html',
  styleUrls: ['./stair.component.scss']
})
export class StairViewComponent extends BaseAdvancedPropertyViewComponent {
  stair: StairsComponent;
  personsPerSquareMeterComponent: PersonsPerSquareMeterComponent = new PersonsPerSquareMeterComponent();
  show:boolean = false;
  showFeaturePersonsPerSquareMeter:boolean;
  stepAmounts = [{ ID: 1, Name: "1" }, { ID: 2, Name: "2" }, { ID: 3, Name: "3" },{ ID: 4, Name: "4" },{ ID: 5, Name: "5" },{ ID: 6, Name: "6+" }];
  constructor(private authService:AuthService, public dialogRef: MatDialogRef<BaseAdvancedPropertyViewComponent>) {
    super(dialogRef);
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.stair = getComponentFromSource(ComponentNames.stairsComponent, this.items);
    this.personsPerSquareMeterComponent = getComponentFromSource(ComponentNames.personsPerSquareMeterComponent, this.items);
    this.showFeaturePersonsPerSquareMeter = userHasFeature(this.authService.getCurrentFeatures(),FeatureEnum.CanOverridePersonsPerSquareMeterOnStairs);
  }

  changeSteps(selectedValue: number) {
    this.stair.numberOfSteps = selectedValue;
  };

  saveButtonDisabledState(): boolean {
    return false;
  }

}
